import { FC } from 'react';

export const MacCardPrompt: FC<{ coverUp?: boolean }> = ({ coverUp }) => {
  const paragraphStyle = 'text-white text-sm font-comfortaa font-medium';
  const prompts = [
    '• Вокруг выбранных карт включится желтая подсветка.',
    '• Когда клиент закончит выбор, попросите клиента нажать на кнопку «Выбрать», чтобы карты отобразились у Вас. Оставшиеся карты скроются.',
    '• Если вы закончили работу, отключить инструмент можно, нажав на иконку включения МАК карт.',
    '• Если вы хотите новый расклад - нажмите повторно на иконку инструмента в нижней части экрана.',
  ];

  return (
    <div className="sm:w-[30vw] lg:w-[15vw] min-w-[300px] h-full flex flex-col pt-[4rem] pl-[1rem]">
      <div className="flex flex-col gap-[13px] md:gap-[20px] lg:gap-[15px] overflow-y-auto pr-[10px] white-scroll mb-5 ">
      <p key="prompt0" className={paragraphStyle}>
        {coverUp
          ? '• Клиент видит всю колоду из 50 карт «картинкой вверх».'
          : '• Клиент видит всю колоду из 50 карт «рубашкой вверх».'}
      </p>
            

      {prompts.map((item, ind) => (
        <p key={`prompt${ind + 1}`} className={paragraphStyle}>
          {item}
        </p>
      ))}
    </div></div>
  );
};
